module.exports = __webpack_public_path__ + "static/media/img-how-qr-code-works-02.146498a5.svg";